<script>
export default {

}
</script>

<template>
  <div>
    <div class="cq-footer">
      <div class="cq-footer-youdian">
        <div>
          <img src="../../assets/footer-1.png" alt="">
          <span>智领行业，品类齐全</span>
        </div>
        <div>
          <img src="../../assets/footer-2.png" alt="">
          <span>轻松对接，快速上线</span>
        </div>
        <div>
          <img src="../../assets/footer-3.png" alt="">
          <span>全场景营销，助力数字升级</span>
        </div>
        <div>
          <img src="../../assets/footer-4.png" alt="">
          <span>7*24小时全面服务</span>
        </div>
      </div>
      <div class="cq-footer-content w1200 cq-footer-main">
        <div class="clearfix">
          <div class="cq-footer-connect">
            <div class="cq-link-box">
              <p class="cq-link-tit">解决方案</p>
              <a href="javascript:(0)" class="cq-link-item">积分</a>
              <a href="javascript:(0)" class="cq-link-item">营销</a>
              <a href="javascript:(0)" class="cq-link-item">福利</a>
            </div>
            <div class="cq-link-box">
              <p class="cq-link-tit">了解我们</p>
              <a href="javascript:(0)" class="cq-link-item">关于全心权益</a>
              <a href="javascript:(0)" class="cq-link-item">常盈权益</a>
              <a href="javascript:(0)" class="cq-link-item">行业案例</a>
              <a href="javascript:(0)" class="cq-link-item">新闻动态</a>
            </div>
            <div class="cq-link-box">
              <p class="cq-link-tit">快速入口</p>
              <a target="_blank" href="https://member.chengquan.cn/open_web/#/login" class="cq-link-item">权益平台</a>
              <a target="_blank" href="https://www.chengquan.cn/platIntro" class="cq-link-item">开放平台</a>
              <a href="https://www.chengquan.cn/supplierCoop" class="cq-link-item">供应商入驻</a>
            </div>
            <div class="cq-link-box cq-link-last">
              <p class="cq-link-tit">友情链接</p>
              <div class="clearfix link-wrap">
                <a target="_blank" href="http://decent.cn/" class="cq-link-item">Decent鼎信</a>
                <a target="_blank" href="https://cn.unionpay.com/" class="cq-link-item">中国银联</a>
                <a target="_blank" href="javascript:(0)" class="cq-link-item">全心权益</a>
                <a target="_blank" href="https://www.boc.cn/" class="cq-link-item">中国银行</a>
                <a target="_blank" href="http://www.abchina.com/cn/" class="cq-link-item">中国农业银行</a>
                <a target="_blank" href="https://www.10086.cn/" class="cq-link-item">中国移动</a>
                <a target="_blank" href="http://www.bankcomm.com/" class="cq-link-item">交通银行</a>
                <a target="_blank" href="http://mall.10010.com/" class="cq-link-item">中国联通</a>
              </div>
            </div>
          </div>
          <div class="cq-footer-contact">
            <div class="cq-footer-service">
              <div class="cq-contact-text">
                <h4>电话：</h4>
              </div>
            </div>
            <div class="cq-footer-qr">
              <!--              <img src="img/pc/footer/QR.png" width="159" height="159" alt="二维码">-->
              <span>微信扫描二维码，关注【权益】</span>
            </div>
          </div>
        </div>
      </div>
      <div class="cq-footer-records">
        <p>©️2024&nbsp;洛阳全心权益科技有限公司&nbsp;&nbsp;
          <a target="_blank" href="http://beian.miit.gov.cn" style="color:#7e8088;font-size:14px;">
            豫ICP备13023321号-26&nbsp;&nbsp;</a>
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=37061302000357" style="color:#7e8088;font-size:14px;">
            <img style="display: inline-block;position: relative;top: 5px;" src="../../assets/police.png" alt="备案">
            &nbsp;&nbsp;鲁公网安备 37061302000357号</a>&nbsp;&nbsp;&nbsp;
          <span style="color:#7e8088;font-size:14px;">增值电信业务经营许可证：豫B2-20241275</span>&nbsp;&nbsp;&nbsp;
          <span style="color:#7e8088;font-size:14px;">增值电信业务经营许可证：豫B2-20241275 </span>&nbsp;&nbsp;&nbsp;
        </p>
      </div>
    </div>
  </div>
</template>

<style>
.cq-footer, .cq-footer a {
  color: #fff
}

.cq-footer, .cq-footer .cq-footer-contact .cq-footer-service, .cq-footer .cq-footer-content, .cq-footer-connect .cq-link-box {
  overflow: hidden
}

.cq-footer {
  margin-top: 150px;
  width: 100%;
  min-width: 1163px;
  height: 554px;
  background-color: #22212f
}

.cq-footer-youdian {
  width: 1200px;
  height: 143px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cq-footer-youdian > div {
  display: flex;
  align-items: center;
}

.cq-footer-youdian img {
  display: inline-block;
}

.cq-footer-youdian span {
  margin-left: 14px;
  //font-family: PingFang-SC-Regular;
  font-size: 20px;
  color: #bcbbcd;
}

.cq-footer-main {
  padding: 43px 0;
  border-top: solid 1px #4c4f5f;
  border-bottom: solid 1px #4c4f5f;
}

.cq-footer .cq-footer-content .cq-footer-contact {
  float: right;
  padding-left: 63px;
  border-left: 1px solid #4c4f5f
}

.cq-footer-contact .cq-footer-service > img {
  float: left;
  padding: 0 10px
}

.cq-footer .cq-footer-contact .cq-contact-text {
  float: left
}

.cq-footer-contact .cq-contact-text h4 {
  //font-family: PingFang-SC-Medium;
  font-size: 20px;
  font-weight: normal;
  color: #fff;
}

.cq-footer-contact .cq-contact-text p {
  font-size: 14px;
  color: #c8c8ca
}

.cq-footer-contact .cq-footer-qr {
  float: right;
  margin-top: 16px
}

.cq-footer-contact .cq-footer-qr img {
  padding-bottom: 8px;
  width: 190px;
  height: 190px;
}

.cq-footer-contact .cq-footer-qr span {
  font-size: 14px;
  color: #cecece;
  //font-family: PingFang-SC-Regular;
}

.cq-footer-content .cq-footer-connect {
  float: left;
  overflow: hidden;
}

.cq-footer-content .cq-footer-connect:first-of-type {
  width: 816px;
  display: flex;
  justify-content: space-between;
}

.cq-footer-connect .cq-link-box {
  float: left;
  margin-right: 120px
}

.cq-footer-connect .cq-link-box.cq-link-last {
  margin-right: 0
}

.cq-footer-connect .cq-link-box.cq-link-last .cq-link-tit {
  text-align: center;
}

.cq-footer-connect .cq-link-box .cq-link-tit {
  display: block;
  padding-bottom: 34px;
  font-size: 16px;
  font-weight: 400;
  font-stretch: normal;
  line-height: 16px;
  color: #fff
}

.cq-footer-connect .cq-link-box .cq-link-item {
  display: block;
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  line-height: 33px;
  color: #cecece
}

.cq-footer-connect .cq-link-box .cq-link-item:hover {
  color: #fff
}

.cq-footer .cq-footer-records {
  height: 60px;
  line-height: 60px;
  text-align: center;
}

.cq-footer .cq-footer-records p {
  width: 1200px;
  margin: 0 auto;
  font-size: 14px;
  //font-family: PingFang-SC-Regular;
  line-height: 60px;
  color: #7e8088;
}

.cq-footer .link-wrap {
  width: 177px;
}

.cq-footer .link-wrap .cq-link-item {
  float: left;
  display: inline-block;
}

.cq-footer .link-wrap .cq-link-item:nth-of-type(odd) {
  width: 85px;
  margin-right: 35px;
}
.center_p{
  text-align: center;
}
.w1200 {
  width: 1200px;
  margin: 0 auto;
}
a{
  text-decoration: none;
}
</style>
